import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../components/NewProductEdit.css"; // ❌ CSS NOT TOUCHED

export default function EditProductPage() {
  const { product_id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState({
    category_id: "",
    name: "",
    mrp: "",
  });

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  /* =========================
   * FETCH DATA
   * ========================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = (localStorage.getItem("session_token") || "").trim();

        /* Fetch categories */
        const catRes = await fetch(
          `https://newerp.awasthivitality.com/api/category/list${
            token ? `?token=${encodeURIComponent(token)}` : ""
          }`,
          {
            headers: token
              ? {
                  Authorization: `Bearer ${token}`,
                  "X-Session-Token": token,
                }
              : {},
          }
        );
        const catJson = await catRes.json();
        setCategories(catJson.data || catJson || []);

        /* Fetch product */
        const prodRes = await fetch(
          `https://newerp.awasthivitality.com/api/products/edit/${product_id}${
            token ? `?token=${encodeURIComponent(token)}` : ""
          }`,
          {
            headers: token
              ? {
                  Authorization: `Bearer ${token}`,
                  "X-Session-Token": token,
                }
              : {},
          }
        );

        const prodJson = await prodRes.json();
        const p = prodJson.data || {};

        setProduct({
          category_id: p.category_id || "",
          name: p.product_name || "",
          mrp: p.prodcut_mrp || "",
        });
      } catch (err) {
        console.error(err);
        toast.error("⚠️ Failed to load product data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [product_id]);

  /* =========================
   * HANDLE CHANGE
   * ========================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* =========================
   * UPDATE PRODUCT
   * ========================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setUpdating(true);

    try {
      const token = (localStorage.getItem("session_token") || "").trim();

      const response = await fetch(
        `https://newerp.awasthivitality.com/api/products/update/${product_id}`,
        {
          method: "PUT", // ✅ MUST BE PUT
          headers: {
            "Content-Type": "application/json",
            ...(token && {
              Authorization: `Bearer ${token}`,
              "X-Session-Token": token,
            }),
          },
          body: JSON.stringify({
            category_id: product.category_id,
            product_name: product.name,
            prodcut_mrp: product.mrp, // ✅ DB COLUMN NAME
          }),
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        toast.success(" Product updated successfully!");
        setTimeout(() => navigate("/Product"), 1500);
      } else {
        toast.error(result.msg || " Update failed");
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("⚠️ Network error while updating product.");
    } finally {
      setUpdating(false);
    }
  };

  if (loading) return <p className="ep-loading">Loading product data...</p>;

  /* =========================
   * RENDER
   * ========================= */
  return (
    <div className="ep-container">
      <form className="ep-form" onSubmit={handleSubmit}>
        <h2 className="ep-title">Edit Product Entry (ID: {product_id})</h2>

        <div className="ep-row">
          <div className="ep-group">
            <label>
              {/* Select Category <span className="ep-required">*</span> */}
            </label>
            <select
              name="category_id"
              value={product.category_id}
              onChange={handleChange}
             
            >
              <option value="">-- Select Category --</option>
              {categories.map((cat) => (
                <option key={cat.category_id} value={cat.category_id}>
                  {cat.category_name || cat.name}
                </option>
              ))}
            </select>
          </div>

          <div className="ep-group">
            <label>
              {/* Product Name <span className="ep-required">*</span> */}
            </label>
            <input
              type="text"
              name="name"
              value={product.name}
              onChange={handleChange}
          
            />
          </div>

          <div className="ep-group">
            <label>
              {/* MRP <span className="ep-required">*</span> */}
            </label>
            <input
              type="number"
              name="mrp"
              value={product.mrp}
              onChange={handleChange}
              
            />
          </div>
        </div>

        <div className="ep-button-box">
          <button type="submit" className="ep-btn" disabled={updating}>
            {updating ? "Updating..." : "Update"}
          </button>
        </div>
      </form>

      <ToastContainer position="top-right" autoClose={2500} />
    </div>
  );
}